import { AppModal, PrimaryButton } from '@lib/common';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var useConfirmSubmissionAudioModal = function useConfirmSubmissionAudioModal(_ref) {
  var labels = _ref.labels,
      sections = _ref.sections,
      onConfirmPlayAudio = _ref.onConfirmPlayAudio;

  var _useState = useState(false),
      showInitialAudioModal = _useState[0],
      setShowInitialAudioModal = _useState[1];

  var _useState2 = useState(false),
      hasConfirmedAudio = _useState2[0],
      setHasConfirmedAudio = _useState2[1];

  var submissionHasAudio = useMemo(function () {
    return sections === null || sections === void 0 ? void 0 : sections.some(function (section) {
      return section.audioFile;
    });
  }, [sections]);
  var handleStartAudio = useCallback(function () {
    setHasConfirmedAudio(true);
    setShowInitialAudioModal(false);
    onConfirmPlayAudio === null || onConfirmPlayAudio === void 0 ? void 0 : onConfirmPlayAudio();
  }, [onConfirmPlayAudio]);
  useEffect(function () {
    if (!sections) return;

    if (submissionHasAudio && !hasConfirmedAudio && !showInitialAudioModal) {
      setShowInitialAudioModal(true);
    } else if (!submissionHasAudio) {
      setHasConfirmedAudio(true);
      onConfirmPlayAudio === null || onConfirmPlayAudio === void 0 ? void 0 : onConfirmPlayAudio();
    }
  }, [sections, submissionHasAudio, hasConfirmedAudio, showInitialAudioModal, onConfirmPlayAudio]);
  var SubmissionAudioConfirmModal = useCallback(function () {
    return /*#__PURE__*/_jsx(AppModal, {
      title: labels.informAudioAutoPlayModalTitle || 'Audio Confirmation',
      open: showInitialAudioModal,
      centered: true,
      closable: false,
      footer: /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(PrimaryButton, {
          onClick: handleStartAudio,
          children: labels.confirm || 'Confirm'
        })
      }),
      children: labels.informAudioAutoPlayModalContent || 'This assignment contains audio content. Please confirm to continue.'
    }) // eslint-disable-next-line react-hooks/exhaustive-deps
    ;
  }, [showInitialAudioModal, handleStartAudio]);
  return {
    showInitialAudioModal: showInitialAudioModal,
    setShowInitialAudioModal: setShowInitialAudioModal,
    hasConfirmedAudio: hasConfirmedAudio,
    handleStartAudio: handleStartAudio,
    submissionHasAudio: submissionHasAudio,
    SubmissionAudioConfirmModal: SubmissionAudioConfirmModal
  };
};